import {
  AssignmentInd,
  Lock,
  MedicalServices
} from "@mui/icons-material";
import * as yup from "yup";

export const referralCreationStepsInfo = [
  { icon: Lock, title: "Re-Referral Details" },
  { icon: MedicalServices, title: "Medical Services" },
  { icon: AssignmentInd, title: "ID Proof & Documents" },
  { icon: AssignmentInd, title: "Remark & New Documents" },
];

export const referralCreateInitData = {
  patientId: "",
};

const referralCreationValidationFirstStep = {
  patientId: yup.string().required("Patient is required"),
};

export const referralCreationValidationSchema = [
  yup.object().shape({ ...referralCreationValidationFirstStep }),
];

// ------------------------------------------------------------

export const referralInitData = {
  patientId: "",
  remark: "",
  checkPreviousDocuments: false,
  name: "",
  year: 0,
  month: 0,
  day: 0,
  sex: "MALE",
  parentsName: "",
  district: "",
  village: "",
  address: "",
  phone: "",
  email: "",
  medicalHistory: "",
  lastTreatingDrNmae: "",
  drClinicLocaton: "",
  adharCard: [],
  lalCard: [],
  panCard: [],
  card: [
    // {
    //   label: "AADHAAR",
    //   path: "file uploaded url",
    // },
  ],
  isLowerIncomeBeneficiary: "false",
  incomeCertificate: [],
  department: "",
  diseaseGroup: "",
  reasonForReferral: "",
  finalDiagnosis: "",
  supportiveDocs: [
    // {
    //   label: "doc1",
    //   path: "file uploaded url",
    // },
  ],
  referralDocuments: [
    // {
    //   label: "doc1",
    //   path: "file uploaded url",
    // },
  ],
};

const patientInfoStepValidation = {
  patientId: yup.string().required("Patient is required"),
  // name: yup.string().required("Name is required"),
  // year: yup
  //   .number()
  //   .min(0, "Invalid age")
  //   .max(150, "Year limit exceeded")
  //   .required("Year is required"),
  // month: yup
  //   .number()
  //   .min(0, "Invalid age")
  //   .max(12, "Month limit exceeded")
  //   .required("Month is required"),
  // day: yup
  //   .number()
  //   .min(0, "Invalid age")
  //   .max(31, "Date limit exceeded")
  //   .required("Date is required"),
  // sex: yup.string().required("Gender is required"),
  // parentsName: yup.string().required("Parents Name is required"),
  // district: yup.string().required("District is required"),
  // village: yup.string().required("Block is required"),
  // address: yup.string().required("Village/Town/Area is required"),
  // phone: yup.string().required("Phone is required"),
  // email: yup.string().email("Invalid email address"),
};

const medicalInfoStepValidation = {
  // medicalHistory: yup.string().required("Medical history is required"),
  // department: yup.string().required("Department is required"),
  // diseaseGroup: yup.string().required("Treatment is required"),
  // finalDiagnosis: yup.string().required("Final Diagnosis is required"),
  // lastTreatingDrNmae: yup.string().required("Referral doctor name is required"),
  // reasonForReferral: yup.string().required("Reason for referral is required"),
};

const idAndDocumentsStepValidation = {
  // incomeCertificate: yup.array().when("isLowerIncomeBeneficiary", {
  //   is: "true",
  //   then: yup
  //     .array()
  //     .of(
  //       yup.object().shape({
  //         label: yup.string().required(),
  //         path: yup.string().required(),
  //       })
  //     )
  //     .min(1, "Income Certificate is required")
  //     .required("Income Certificate is required"),
  //   otherwise: yup.array().notRequired(),
  // }),
  // card: yup
  //   .array()
  //   .of(
  //     yup.object().shape({
  //       label: yup.string().required(),
  //       path: yup.string().required(),
  //     })
  //   )
  //   .min(1, "Identification is required"),
  // supportiveDocs: yup
  //   .array()
  //   .of(
  //     yup.object().shape({
  //       label: yup.string().required(),
  //       path: yup.string().required(),
  //     })
  //   )
  //   .min(1, "Supportive doc is required")
  //   .required("Supportive doc is required"),
};

const referralRemarkAndNewDocumentsStepValidation = {
  remark: yup.string().required("Remark is required"),
  // referralDocuments: yup.array().required("Referral documents are required"),
};

export const referralValidationSchema = [
  yup.object().shape(patientInfoStepValidation),
  yup.object().shape(medicalInfoStepValidation),
  yup.object().shape(idAndDocumentsStepValidation),
  yup.object().shape(referralRemarkAndNewDocumentsStepValidation),
];
